module.exports = __webpack_public_path__ + "static/media/shouru.cd7f0230.png";